export const constrainValue = (value: number, min: number, max: number) => {
  const val = +value;
  if (isNaN(val)) {
    return min;
  }
  if (value < min) {
    return min;
  }
  if (max && value > max) {
    return max;
  }
  return value;
};
